import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../../../utils/apiConfig";
import SubPageLayout from "../../../components/shared/SubPageLayout";

import logger from '../../../utils/logger';

const Investments = () => {
  const { householdId } = useParams();
  const [household, setHousehold] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHouseholdData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          logger.info("No token found");
          return;
        }

        const response = await api.get("/advisor/clients");

        const targetHousehold = response.data.find(
          (client) => client.householdId.toString() === householdId,
        );
        if (targetHousehold) {
          setHousehold(targetHousehold);
        }
      } catch (err) {
        logger.error("Error fetching household data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHouseholdData();
  }, [householdId]);

  if (loading) {
    return (
      <SubPageLayout
        title="Loading..."
        subtitle="View household investments"
        breadcrumbItems={[
          { label: "Advisor Portal", path: "/advisor-portal" },
          { label: "Client Database", path: "/advisor-portal/client-database" },
          {
            label: "Household Profile",
            path: `/advisor-portal/client-database/household-profile/${householdId}`,
          },
          {
            label: "Investments",
            path: `/advisor-portal/client-database/household-profile/${householdId}/investments`,
          },
        ]}
      >
        <div className="text-center py-4">Loading...</div>
      </SubPageLayout>
    );
  }

  return (
    <SubPageLayout
      title={`${household?.members[0]?.lastName || "Household"} Investments`}
      subtitle="View household investments"
      breadcrumbItems={[
        { label: "Advisor Portal", path: "/advisor-portal" },
        { label: "Client Database", path: "/advisor-portal/client-database" },
        {
          label: "Household Profile",
          path: `/advisor-portal/client-database/household-profile/${householdId}`,
        },
        {
          label: "Investments",
          path: `/advisor-portal/client-database/household-profile/${householdId}/investments`,
        },
      ]}
    >
      <div className="bg-surface-default dark:bg-surface-default p-6 rounded-lg shadow">
        {/* Content will be added later */}
      </div>
    </SubPageLayout>
  );
};

export default Investments;
